import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function RetailReturnPolicy() {
    const location = useLocation();
   useEffect(() => {
      window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className="w-screen bg-white py-10 lg:py-16 xl:py-24 px-4 lg:px-16 xl:px-24 text-gray-900">
            <div className="py-16">
                <div>
                    <h1 className="text-4xl font-bold mb-8 text-center">
                        Change of Mind
                        <br /> Return/Exchange Policy</h1>

                    <section>
                        <p>If you are not completely satisfied with your purchase, you may return your item to your preferred Harvey Norman store (including products purchased online), within 14 days from the date you receive the goods, for exchange, Gift Card, or refund (terms and conditions, and exclusions apply). The item must be:</p>
                        <p>&nbsp;</p>

                        <ul className="list-disc ml-6 lg:ml-12">
                            <li>In saleable and undamaged condition;</li>
                            <li>In its original unopened and sealed packaging; and</li>
                            <li>This policy is in addition to, and is not intended to limit, any rights or remedies you may have under the Consumer Guarantees Act.</li>
                        </ul>
                        <p>&nbsp;</p>

                        <p>This policy does not impact your rights where a product may be faulty, damaged, or incorrectly supplied. If an item is faulty/damaged/incorrectly supplied, we will meet our obligations under the Consumer Guarantees Act to provide a remedy.</p>
                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4">Terms and Conditions</h3>

                        <p>Unfortunately, we are unable to accept change of mind returns for exchange, refund or Gift Card:</p>

                        <p>&nbsp;</p>

                        <ul className="list-disc ml-6 lg:ml-12">
                            <li>That were purchased more than 14 days ago;</li>
                            <li>That are not in their original unopened condition and packaging; or</li>
                            <li>Without proof of purchase.</li>
                        </ul>
                        <p>&nbsp;</p>

                        <p>Product must be returned to a Harvey Norman store. We will offer (at Harvey Norman’s sole discretion) either an exchange, Gift Card, or refund.</p>
 
 <p>&nbsp;</p>

                        <p>If applicable, you will be charged for shipping and any other costs associated with returning the product to Harvey Norman.</p>
                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4">Exclusions:</h3>

                        <p>Products from the categories listed below are excluded from this policy (except where they are faulty):</p>

<p>&nbsp;</p>

                        <ul className="list-disc ml-6 lg:ml-12">
                            <li>Personal care, hygiene, and grooming.</li>
                            <li>Gift Cards, SIM Cards, recharge cards, and vouchers (e.g., iTunes cards, mobile phone top-ups).</li>
                            <li>EPAY software and games.</li>
                            <li>Items marked ‘display’ or ‘floor stock’.</li>
                            <li>Seconds and Clearance items (includes sales marked as ‘final’ from Outlet stores).</li>
                            <li><strong>Customised and special orders (see your salesperson for further details).</strong></li>
                            <li>Pillows, mattress protectors, and bed linen.</li>
                            <li>Beds, mattresses, and bedroom furniture.</li>
                            <li>Shipping, delivery, and installation fees.</li>
                            <li><strong>Commercial and cabinetry.</strong></li>
                        </ul>
                        <p>&nbsp;</p>

                        <p>This list is not exhaustive. See your preferred store for details of specific products. The ultimate discretion to provide an exchange, refund or Gift Card remains with the store.</p>
                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4">Exchange</h3>

                        <p>If exchanging your item for another product, and:</p>

                        <p>&nbsp;</p>

                        <ul className="list-disc ml-6 lg:ml-12">
                            <li>The selected product is a lower value, we will refund, or offer a Gift Card, for the difference between the purchase price of the original product and the selected exchange product.</li>
                            <li>The selected product is a higher value, you will be charged for the difference between the purchase price of the original product and the selected exchange product.</li>
                        </ul>

                        <p>&nbsp;</p>

                        <p>If a suitable product is not available for exchange, you will be offered a refund or Gift Card.</p>
                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4">Refunds</h3>

                        <p>Refunds are processed using the same tender type as the original method of payment. If the purchase was originally financed, the item may be refunded or exchanged (Gift Cards are not available). For amounts refunded via internet transfer into the bank account provided, please allow seven (7) business days.</p>
                    </section>

                </div>
            </div>
        </div>

    );
};
